import * as mutationTypes from './mutationTypes'

export default {
  [mutationTypes.SET_REGISTER_LOCATIONS](state, data) {
    state.registerLocations = data
  },
  [mutationTypes.SET_PROVINCES](state, data) {
    state.provinces = data
  },
}
